// Curated daily motivational quotes for the Catalina Dental sales/team huddle.
// Rotates deterministically by day-of-year — the whole team sees the same quote each day.

const QUOTES = [
  { q: "People don't buy treatment — they buy confidence.", a: "Catalina Dental" },
  { q: "The consult isn't won in the chair. It's won in the follow-up.", a: "Catalina Dental" },
  { q: "Every smile we change is a life we change.", a: "Catalina Dental" },
  { q: "You don't close a sale, you open a relationship.", a: "Patricia Fripp" },
  { q: "Sales is the transference of feeling.", a: "Zig Ziglar" },
  { q: "Your attitude, not your aptitude, will determine your altitude.", a: "Zig Ziglar" },
  { q: "Approach each patient with the idea of helping them solve a problem.", a: "Brian Tracy" },
  { q: "Treat objections as requests for further information.", a: "Brian Tracy" },
  { q: "Make a patient, not a sale.", a: "adapted from Katherine Barchetti" },
  { q: "Setting goals is the first step in turning the invisible into the visible.", a: "Tony Robbins" },
  { q: "Champions keep playing until they get it right.", a: "Billie Jean King" },
  { q: "Discipline is the bridge between goals and accomplishment.", a: "Jim Rohn" },
  { q: "Success is the sum of small efforts repeated day in, day out.", a: "Robert Collier" },
  { q: "Hard work beats talent when talent doesn't work hard.", a: "Tim Notke" },
  { q: "Quality is remembered long after the price is forgotten.", a: "Aldo Gucci" },
  { q: "Confidence is contagious. So is the lack of it.", a: "Vince Lombardi" },
  { q: "If you are not taking care of your patient, your competitor will.", a: "adapted from Bob Hooey" },
  { q: "The harder I work, the luckier I get.", a: "Samuel Goldwyn" },
  { q: "Your most unhappy patients are your greatest source of learning.", a: "adapted from Bill Gates" },
  { q: "Don't watch the clock; do what it does. Keep going.", a: "Sam Levenson" },
  { q: "Listen twice as much as you talk.", a: "Zig Ziglar" },
  { q: "Great things are not done by impulse, but by a series of small things brought together.", a: "Vincent van Gogh" },
  { q: "The expert in anything was once a beginner.", a: "Helen Hayes" },
  { q: "Success is liking yourself, liking what you do, and liking how you do it.", a: "Maya Angelou" },
  { q: "Don't be afraid to give up the good to go for the great.", a: "John D. Rockefeller" },
  { q: "Every no is one consult closer to yes.", a: "Catalina Dental" },
  { q: "Slow is smooth. Smooth is fast. Smooth closes.", a: "Catalina Dental" },
  { q: "The patient remembers how you made them feel — long after the treatment plan.", a: "Catalina Dental" },
  { q: "Curiosity closes more cases than persuasion.", a: "Catalina Dental" },
  { q: "Be so good they can't ignore you.", a: "Steve Martin" },
  { q: "Excellence is not an act, but a habit.", a: "Aristotle" },
  { q: "What gets measured gets managed.", a: "Peter Drucker" },
  { q: "If you're not making someone else's life better, then you're wasting your time.", a: "Will Smith" },
  { q: "Show up. Be kind. Tell the truth. Close the case.", a: "Catalina Dental" },
  { q: "Today's effort is tomorrow's referral.", a: "Catalina Dental" },
];

export function getDailyQuote(date = new Date()) {
  // Day-of-year index — same for the whole team on the same day.
  const start = Date.UTC(date.getUTCFullYear(), 0, 0);
  const diff = Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate()) - start;
  const dayOfYear = Math.floor(diff / 86400000);
  return QUOTES[dayOfYear % QUOTES.length];
}

export default QUOTES;
